/**
 * External Dependencies
 */
import 'jquery';
import barba from '@barba/core';
import barbaCss from '@barba/css';
import Isotope from 'isotope-layout';
import youtubeBg from 'youtube-background';

$(document).ready(() => {

  // Supprime Barba des liens de l'admin bar
  document.querySelectorAll("#wpadminbar a").forEach(item => item.setAttribute('data-barba-prevent', 'self'));

  // Les constantes
  const hamburger = $('.hamburger');
  const navigationOverlay = $('.js-mobile-menu');
  const close = $('.js-close');
  const searchOverlay = $('.js-search-layout');
  const html = $('html');
  const body = $('body');

  // FILTRES !

  // on choppe le hash
  function getHashFilter() {
    var matches = location.hash.match(/filter=([^&]+)/i);
    var hashFilter = matches && matches[1];
    return hashFilter && decodeURIComponent(hashFilter);
  }


  var videoFilters = {
    doFilter(iso) {
      // au chargement on check si y a un hash et si y en un on filtre

      var hashFilter = getHashFilter();
      if (hashFilter !== '') {
        iso.arrange({
          filter: hashFilter,
        });
      }
      // si on clique sur un bouton on filtre
      $('.filter-button-group').on('click', 'button', function () {
        // on met à zéro des variables
        var filterValue = "";
        var dataValue = ""

        // on choppe le data-filter
        dataValue = $(this).attr('data-filter');
        // on le met la filter value à zero si elle est égale au data
        // et sinon on la sette
        if (filterValue === dataValue) {
          filterValue = ''
        } else {
          filterValue = dataValue
        }

        // on sette l'url avec le hash
        location.hash = 'filter=' + encodeURIComponent(filterValue);

        // cosmétique: si le click est sur un "parent" on cache les "enfants" d'abord
        //avant d'allumer les enfants qui incluent la string du parent
        if ($(this).hasClass('parent')) {
          var $subs = $(".sub-filtre")
          $subs.addClass('hidden')
          var $subfiltres = $(".sub-filtre").filter(function () {
            return $(this).data("filter").includes(dataValue);
          });
          $subfiltres.removeClass('hidden')
        }

        iso.arrange({
          filter: dataValue,
        });
      });

    },
  }


  function afficheNavigation() {
    // Chope le hash
    var hashFilter = getHashFilter();
    // efface tout le monde
    $('.filter-button-group').find('.filtre-actif').removeClass('filtre-actif');
    if (hashFilter) {
      // le parent actif est rouge
      $('.filter-button-group').find('[data-filter="' + hashFilter + '"]').addClass('filtre-actif');
      // enfant actif est rouge
      // s'il y a un - on chope la première partie
      var parent_slug = hashFilter.split('-')[0];
      $('.parents').find('[data-filter="' + parent_slug + '"]').addClass('filtre-actif');
      // on affiche ceux qui ont aussi le parent dans le slug (le meme niveau)
      var $subfiltres = $(".sub-filtre").filter(function () {
        return $(this).data("filter").includes(parent_slug);
      });
      $subfiltres.removeClass('hidden')
    }
  }

  $(window).on('hashchange', afficheNavigation);

  // end filters

  // start barba

  barba.use(barbaCss);

  barba.init({
    views: [{
        namespace: 'accueil',
        beforeEnter() {

           $('[data-youtube]').youtube_background({});
          // var vid = document.getElementById("bgvid");

          // function playVid() {
          //   vid.play();
          // }

          // function pauseVid() {
          //   vid.pause();
          // }
          // playVid()

        },
      },
      {
        namespace: 'videos',
        beforeEnter() {


          // filter items on button click
          afficheNavigation()


          var elem = document.querySelector('.isotope');

          // on instancie isotope
          /* eslint-disable-next-line */
          var iso = new Isotope(elem, {
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
          });
          videoFilters.doFilter(iso)
        },
      },
    ],
  });
  barba.hooks.afterLeave(data => {

    // Update the active menu item classes
    //alert(data.next.url.path)
    if (data.next.url.path) {
      const activeClass = 'current-menu-item';

      $('.current-menu-item').each(function () {
        $(this).removeClass(activeClass);
      });
      if (data.next.url.path === '/') {
        // force accueil
        $('.menu-item-29213').addClass(activeClass);
      } else {
        $(`.menu-item > a[href$="${data.next.url.path}"]`).closest('.menu-item').each(function () {
          $(this).addClass(activeClass);
        });
      }
    }
    // on ferme la recherche
    if ($('body').hasClass('menu-is-open')) {
      closeSearch(navigationOverlay, searchOverlay, html, body)
    }

  });
  barba.hooks.enter(() => {
    // ajoute les classe au body
    $('body').attr('class', $('#body-classes').attr('class'));
    // remonte la page
    $("html, body").animate({
      scrollTop: 0,
    }, "slow");

  });



  function closeSearch(navigationOverlay, searchOverlay, html, body) {
    navigationOverlay.addClass('hidden').removeClass('is-open');
    searchOverlay.removeClass('is-open');
    html.removeClass('menu-is-open overflow-hidden');
    body.removeClass('menu-is-open');
    $('.search-results').hide();
  }

  // ouvrir le menu
  hamburger.on('click', function () {
    // console.log('MENU OPEN')
    hamburger.toggleClass('is-active');
    navigationOverlay.toggleClass('hidden').toggleClass('is-open');
    html.toggleClass('menu-is-open overflow-hidden');
    //body.toggleClass('overflow-hidden');
  });

  // Ouvrir la recherche (clic sur la loupe)
  $(document).on('click', '.js-search', function () {
    $(this).toggleClass('is-active');
    searchOverlay.toggleClass('is-open');
    document.getElementById('js-search-keyword').focus()
    html.toggleClass('menu-is-open overflow-hidden');
    body.toggleClass('menu-is-open');

    // ré-affiche le résultat de recherche
    $('.search-results').show();
  });

  // petite croix qui ferme le menu
  close.on('click', function () {
    navigationOverlay.addClass('hidden').removeClass('is-open');
    searchOverlay.removeClass('is-open');
    html.removeClass('menu-is-open overflow-hidden');
    body.removeClass('menu-is-open');
  });

  //
  $('#menu_desktop li.menu-item-has-children > a').attr('href', '#');
  // ferme le menu quand on clique sur un lien mobile
  $('#menu_desktop li.menu-item-has-children > a').on('click', function (e) {
     e.preventDefault();
  });



  $('#menu_mobile li a').on('click', function (e) {

    if ($(this).parent().hasClass('menu-item-29266')) {
      e.preventDefault();
      $(this).parent().find('.sub-menu').slideToggle()
      $(this).parent().toggleClass('open')
    } else {
      navigationOverlay.addClass('hidden').removeClass('is-open');
      searchOverlay.removeClass('is-open');
      html.removeClass('menu-is-open overflow-hidden');
      body.removeClass('menu-is-open');
    }

  });



  // ferme la recherche si on clique sur le body mais pas sur l'input
  if ($('.search-results')) {
    $('.js-overlay').on('click', function (e) {
      if (e.target.id !== 'js-search-keyword') {
        closeSearch(navigationOverlay, searchOverlay, html, body)
      }
    });
  }

  $(document).on('click', '.js-back', function () {
    window.location = window.location.origin + '/videos/'
  });

});
